import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

let cancelToken;
const getClassDistributionReport = (
  className,
  fromDate,
  pageNumber,
  pageSize,
  reportMode,
  toDate,
  trainingType
) => {
  cancelToken = getAxiosCancelToken(cancelToken);

  if (reportMode === "View") {
    return apiRequestType(
      apiTypes.GET,
      apiConstants.REPORT.TABULAR_REPORT.CLASS_DISTRIBUTION_REPORT(
        className,
        fromDate,
        pageNumber,
        pageSize,
        reportMode,
        toDate,
        trainingType
      ),
      "",
      cancelToken
    );
  } else {
    let url =
      encodeURIComponent(apiConstants.BASE_URL_1) +
      encodeURIComponent(
        apiConstants.REPORT.TABULAR_REPORT.CLASS_DISTRIBUTION_REPORT(
          className,
          fromDate,
          pageNumber,
          pageSize,
          reportMode,
          toDate,
          trainingType
        )
      );
    let template = "ShotClassDistributionReport";
    return apiRequestType(
      apiTypes.GET,
      apiConstants.REPORT.CSV_REPORT(url, template),
      "",
      cancelToken
    );
  }
};

export default getClassDistributionReport;
